// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","promo":"promo-1WC6J","promo__image":"promo__image-UosII"};